import store from "../@store";
import { request } from '../@utils'

export default {
  // 获取特殊分类
  getSpecialProductList: () => {
    return request.get('/common/getPartnerCategory')
  },
  // 包邮详情
  getPackageDetails: (storeCode) => {
    return request.get('freight/detailByStoreCode/' + storeCode)
  },
  // 保存包邮
  savePackageDetails: (data) => {
    return request.post('freight/save', {
      data
    })
  },
  // 广告/
  // 新增
  addAdvertisement: (data) => {
    return request.post('mallPageBanner/create', {
      data
    })
  },
  // 删除
  deleteAdvertisement: (id) => {
    return request.post('mallPageBanner/delete/'+id)
  },
  // 详情
  getDetailAdvertisement: (id) => {
    return request.get('mallPageBanner/detail/'+id)
  },
  // 列表
  getListAdvertisement: (data) => {
    return request.post('mallPageBanner/list', {
      data
    })
  },
  // 编辑
  editAdvertisement: (data) => {
    return request.post('mallPageBanner/update', {
      data
    })
  },
  // 金刚区
  // 新增
  addVajraDistrict: (data) => {
    return request.post('mallPageGrideMenu/create', {
      data
    })
  },
  // 删除
  deleteVajraDistrict: (id) => {
    return request.post('mallPageGrideMenu/delete/'+id)
  },
  // 详情
  getDetailVajraDistrict: (id) => {
    return request.get('mallPageGrideMenu/detail/'+id)
  },
  // 列表
  getListVajraDistrict: (data) => {
    return request.post('mallPageGrideMenu/list', {
      data
    })
  },
  // 编辑
  editVajraDistrict: (data) => {
    return request.post('mallPageGrideMenu/update', {
      data
    })
  },
  // 商品推荐
  // 新增
  addProductRecommend: (data) => {
    return request.post('mallPageProduct/create', {
      data
    })
  },
  // 列表
  getProductList: (data) => {
    return request.post('mallPageProduct/list', {
      data
    })
  },
  // 编辑
  editProduct: (data) => {
    return request.post('mallPageProduct/update', {
      data
    })
  },
  // 删除
  deleteProduct: (id) => {
    return request.post('mallPageProduct/delete/' + id)
  },
  // 详情
  getProductDetail: (id) => {
    return request.get('mallPageProduct/detail/' + id)
  },
  // 编码查询
  searchProductCode: (data) => {
    return request.post('mallPageProduct/queryStoreProduct', {
      data
    })
  }
}